<div class="spinner-container" [class.fullscreen]="fullscreen">
  <div class="spinner" [class]="spinnerClasses"></div>

  @if (loadingText) {
    <div class="loading-text">
      @if (translate) {
        {{ loadingText | translate }}
      } @else {
        {{ loadingText }}
      }
    </div>
  }
</div>
